/*
 * @Author: liyifan
 * @Date: 2025-04-27 11:40:07
 * @Last Modified by: liyifan
 * @Last Modified time: 2025-08-28 14:29:24
 * @description:批量购买
 */
import './index.less'
import { createApp } from 'vue/dist/vue.esm-browser.js';
import { Decimal } from 'decimal.js'
import { validZip, verifyEmail } from '@utils/index.js'
import { shopCR } from "@utils/api.js"
import { countryStreetInfo, batchPurchaseUpload, uploadBatchPurchaseInfo, downloadBatchPurchaseExcal, downloadJpBatchPurchaseExcal } from '@utils/api.js'
$(document).ready(function() {
    createApp({
        delimiters: ['${', '}'],  // Vue模板分隔符
        data() {
            return {
                active: 'pps',  // 当前激活的导航项
                isUpload: false,  // 是否已上传文件
                visible: false,  // 弹窗是否可见
                uploadLoading: false,  // 文件上传加载状态
                submitUploadLoading: false,  // 提交上传加载状态
                submitLoading: false,  // 提交加载状态
                fileName: '',  // 上传文件名
                form: {  // 表单数据
                    first: '',
                    last: '',
                    email: '',
                    phone: '',
                    company: '',
                    industry: '',
                    certificate: '',
                    state: '',
                    city: '',
                    zipCode: '',
                    detailAddress: ''
                },
                list: [],  // 产品列表
                showMore: false,  // 是否显示更多
                totalPrice: 0,  // 总价
                subTotalPrice: 0,  // 小计
                totalPriceFormat: '',  // 格式化后的总价
                subTotalPriceFormat: '',  // 格式化后的小计
                discountInfo: {},  // 折扣信息
                moneyFormat: pageInfo.currency.money_format,  // 货币格式
                formatMoney,  // 格式化金额函数
                isDownloadExcal: false,  // 是否下载Excel
                typeList: [],  // 类型列表
                quoteButtonLoading: false,  // 报价按钮加载状态
                orMore: $('.batch-purchase-unit-off').attr('data-orMore'),  // 更多信息
                module: '',  // 当前模块
                slidesPerView: 6,  // 每页显示数量
                productList: [],  // 产品列表
                modalList: [],  // 弹窗中的产品信息
                tailorNumber: 1,
                tailorList:  [  // 定制产品列表
                    {
                        type: '',
                        variantId: undefined,
                        quantity: 1,
                        list: []
                    }
                ],
                stateList: [],  // 州列表
                faqIndex: 1,  // FAQ索引
                detailShow: false, // 详情弹窗是否显示
                formErrors: [],
                require: "",
            }
        },
        methods: {
            // 获取产品列表
            async getList() {
                const ppsList = JSON.parse(document.querySelector("#batch-purchase-pps")?.innerText || "[]")
                const sgList = JSON.parse(document.querySelector("#batch-purchase-sg")?.innerText || "[]")
                const spList = JSON.parse(document.querySelector("#batch-purchase-sp")?.innerText || "[]")
                const accList = JSON.parse(document.querySelector("#batch-purchase-acc")?.innerText || "[]")
                const productOriginList = [...ppsList, ...spList, ...sgList, ...accList]
                this.productList = []
                const aiodObj = {}
                productOriginList.forEach(item => {
                    const discountList = item.discountList.filter(item => !item.includes(0))
                    const curQuantity = item.quantity || 1
                    const obj = {
                        ...item,
                        quantity: curQuantity,
                        discountList
                    }
                    this.productList.push(obj)
                    Object.assign(aiodObj, {
                        [item.sku]: discountList.map(item=> ({
                            minRange: item[0],
                            maxRange: 1,
                            discountPercent: item[1]
                        }))
                    })
                })
                const unit = $('.batch-purchase-unit-off').attr('data-unit')
                const off = $('.batch-purchase-unit-off').attr('data-off')
                const orMore = $('.batch-purchase-unit-off').attr('data-orMore')
                Object.keys(aiodObj).forEach(key => {
                    let html = ''
                    let items = ''
                    aiodObj[key].forEach((item, index) => {
                        items += `
                        <div class="discount-item">
                            <span class="info">
                                ${ index != aiodObj[key].length -1 ?  `${item.minRange} - ${ aiodObj[key][index + 1].minRange - 1 }  ${unit}` : `${item.minRange}  ${unit}  ${orMore}` }
                            </span>
                            <div class="discount">
                                ${item.discountPercent}% ${off}
                            </div>
                        </div>
                        `
                    })
                    html += `${items}`
                    $(`.sku-${key}`).html(html)
                })
            },
            // 选择产品
            handleSelectProduct(sku, module) {
                this.module = module
                const product = this.productList.find(item => item.sku === sku)
                const{discountList, quantity, price} = product
                this.modalList = []
                // 当前产品价格
                let totalPrice = 0 // 折后总价
                let curQuantity= quantity || 1
                // 如果是日站 则quantity为1
                if(['10015375438', '56124375224'].includes(shopId)) {
                    curQuantity = 1
                }
                // 判断当前的数值区间是否满足要求
                if (discountList.length && curQuantity >= discountList[0][0] ) {
                    totalPrice = new Decimal(curQuantity).mul(discountList[0][2]).toNumber()
                } else {
                    totalPrice = new Decimal(curQuantity).mul(price).toNumber()
                }
                const totalPriceFormat = formatMoney(Math.ceil(totalPrice), this.moneyFormat)
                const subTotalPrice = new Decimal(curQuantity).mul(price).toNumber() // 原价
                const subTotalPriceFormat = formatMoney(Math.ceil(subTotalPrice), this.moneyFormat)
                const description  = $(`.description-${product.sku}`).html()

                const obj = {
                    ...product,
                    quantity: curQuantity,
                    totalPrice,
                    totalPriceFormat,
                    subTotalPrice,
                    subTotalPriceFormat,
                    description
                }
                this.list= [obj]
                this.totalPrice = totalPrice
                this.subTotalPrice = subTotalPrice
                this.totalPriceFormat = totalPriceFormat
                this.subTotalPriceFormat = subTotalPriceFormat
                this.handleProductModalShow()
            },
            handleNav(title, name) {
                document.querySelector(`.${title}`).scrollIntoView({ behavior: "smooth",  block:"start"})
                setTimeout(() => {
                    this.active = title
                }, 300)
                const gaParams = {
                    module: "directory",
                    position: name
                }
                this.handleGa(gaParams)
            },
            uploadProof(flag) {
                this.fileName = ''
                this.isDownloadExcal = flag
                $('body').css({ overflow: "hidden"})
                $('.batch-purchase--upload-modal').show()
            },
            // 关闭弹窗
            handleUploadCose() {
                this.form = {
                    first: '',
                    last: '',
                    email: '',
                    phone: '',
                    company: '',
                    industry: '',
                    certificate: '',
                    detailAddress: '',
                    state: '',
                    city: '',
                    zipCode: '',
                }
                $('body').css({ overflow: "inherit" })
                $('.batch-purchase--upload-modal').hide()
            },
            async handleUpload(e) {
                const file = e.target.files[0]
                const  uploadError = $('.batch-purchase--upload').attr('data-upload')
                const uploadSuccess = $('.batch-purchase--upload').attr('data-upload-success')
                if (file) {
                    const size = file.size
                    // 大小
                    if (size > 1024 * 1024 * 10) {
                        pushErrorMessage(uploadError);
                        e.target.value = ''
                        return false
                    }
                    // 类型
                    const type = file.type
                    const typeList= ['image/jpeg', 'application/pdf', 'image/png']
                    if (!typeList.includes(type)) {
                        pushErrorMessage(uploadError);
                        e.target.value = ''
                        return false
                    }
                    this.uploadLoading = true
                    let formData = new FormData();
                    formData.append("file", file);
                    try {
                        const res = await batchPurchaseUpload(4, formData)
                        this.form.certificate = res.data.fileUrl
                        this.fileName = file.name
                        this.isUploadFile = true
                        this.uploadLoading = false
                        pushSuccessMessage(uploadSuccess)
                    } catch (err) {
                        this.form.certificate = ''
                        pushErrorMessage(err.message)
                    } finally {
                        e.target.value = ''
                        this.uploadLoading = false
                    }
                }
            },
            handleCheck() {
                let isCheck = false
                const formError = {
                    first: $('.batch-purchase--upload').attr('data-first'),
                    last: $('.batch-purchase--upload').attr('data-last'),
                    email: $('.batch-purchase--upload').attr('data-email'),
                    phone: $('.batch-purchase--upload').attr('data-phone'),
                    company: $('.batch-purchase--upload').attr('data-company'),
                    industry: $('.batch-purchase--upload').attr('data-industry'),
                    certificate: $('.batch-purchase--upload').attr('data-upload'),
                    detailAddress: $('.batch-purchase--upload').attr('data-detailAddress'),
                    state: $('.batch-purchase--upload').attr('data-state'),
                    city: $('.batch-purchase--upload').attr('data-city'),
                    zipCode: $('.batch-purchase--upload').attr('data-zipCode'),
                }
                try {
                    if (this.isDownloadExcal) {
                        delete this.form.certificate
                        delete this.form.detailAddress
                        delete this.form.state
                        delete this.form.city
                        delete this.form.zipCode
                    }
                    Object.keys(this.form).forEach(key => {
                        if (key !== 'phone') {
                            const val = this.form[key].trim()
                            if (val == '' || (val.length > 255)) {
                                pushErrorMessage(`${formError[key]}`)
                                throw new Error()
                            }
                        }

                    })
                } catch (error) {
                    return isCheck = true
                }

                if (!verifyEmail(this.form.email.trim())) {
                    pushErrorMessage(`${formError.email}`)
                    return isCheck = true
                }

                if (this.form.phone && (this.form.phone.trim().length < 6 || this.form.phone.trim().length > 20)) {
                    pushErrorMessage(`${formError.phone}`)
                    return isCheck = true
                }

                const reg = validZip('US').test(this.form.zipCode)
                if (this.form.zipCode  && !reg) {
                    pushErrorMessage(`${formError.zipCode}`)
                    return isCheck = true
                }

                return isCheck
            },
            // 上传免税证明
            async handleSubmit(buttonText) {
                if (this.handleCheck(true)) {
                    return false
                }
                this.submitUploadLoading = true
                const params = {
                    ...this.form,
                    certificateUrl: this.form.certificate
                }
                try {
                    const res = await uploadBatchPurchaseInfo(params)
                    pushSuccessMessage(res.message)
                    this.handleUploadCose()
                    this.isUpload = true
                    const gaParams = {
                        module: $('.batch-purchase-upload-title').text(),
                        button_name: buttonText
                    }
                    this.handleGa(gaParams)
                } catch (err) {
                    pushErrorMessage(err.message, 3000)
                } finally {
                    this.submitUploadLoading = false
                }
            },
            // 处理弹窗数据
            handleProductModalShow() {
                this.orMore = $('.batch-purchase-unit-off').attr('data-orMore')
                $('body').css({
                    overflow: "hidden"
                })
                $('.batch-purchase--detail').show()
                this.detailShow = true
            },
            handleProductModalHide() {
                this.showMore = false
                $('body').css({overflow: "inherit"})
                $('.batch-purchase--detail').hide()
                this.detailShow = false
            },
            async handleMinus(item) {
                let num = parseInt(item.quantity)
                if (num > 1) {
                    item.quantity = num - 1
                }
                await this.calcItemTotal(item)
                this.calcTotal()
            },
            async handlePlus(item) {
                let num = parseInt(item.quantity)
                item.quantity = num + 1
                await this.calcItemTotal(item)
                this.calcTotal()
            },
            async handleInputBlur(item) {
                item.quantity = +item.quantity
                if (item.quantity < 1) {
                    item.quantity = 1
                }
                await this.calcItemTotal(item)
                this.calcTotal()
            },
            calcItemTotal(item) {
                // 判断当前的数值区间
                const values = item.discountList.map(item => item[0])
                let index = -1
                values.forEach((value, j) => {
                    if(item.quantity >= value) {
                        index = j
                    }
                })
                if (index !== -1) {
                    item.totalPrice = new Decimal(item.quantity).mul(item.discountList[index][2]).toNumber()
                } else {
                    item.totalPrice = new Decimal(item.quantity).mul(item.price).toNumber()
                }

                item.subTotalPrice = new Decimal(item.quantity).mul(item.price).toNumber()
                item.totalPriceFormat = formatMoney(Math.ceil(item.totalPrice) , this.moneyFormat)
                item.subTotalPriceFormat = formatMoney(Math.ceil(item.subTotalPrice) , this.moneyFormat)
                return item
            },
            calcTotal() {
                // 计算总数
                this.totalPrice = 0
                this.subTotalPrice = 0
                this.list.forEach(item => {
                    this.totalPrice = new Decimal(this.totalPrice).add(item.totalPrice).toNumber()
                    this.subTotalPrice = new Decimal(this.subTotalPrice).add(item.subTotalPrice).toNumber()
                })
                this.totalPriceFormat = formatMoney(Math.ceil(this.totalPrice), this.moneyFormat)
                this.subTotalPriceFormat = formatMoney(Math.ceil(this.subTotalPrice), this.moneyFormat)
            },
            // 新增产品
            handleAddProduct() {
                const params = {
                    type: '',
                    variantId: '',
                    quantity: 1,
                    list: []
                }
                const errorParams = {
                     type: '',
                     variantId: ''
                }
                this.tailorList.push(params)
                this.formErrors.push(errorParams)
            },
            // 下载报价单
            async handleDownload(text) {
                if (this.handleCheck(false)) {
                    return false
                }
                this.submitUploadLoading = true
                const skus = []
                this.list.forEach(item => {
                    const {sku, title, quantity, totalPrice, totalPriceFormat } = item
                    const obj = {
                        sku,
                        title,
                        quantity,
                        upc: item.barcode || '',
                        unitCost: formatMoney(totalPrice / quantity, this.moneyFormat),
                        total: totalPriceFormat
                    }
                    skus.push(obj)
                })
                const params = {
                    ...this.form,
                    skus
                }
                try {
                    const res = await downloadBatchPurchaseExcal(params)
                    if (res.type === 'application/json') {
                        res.text().then(text => {
                            pushErrorMessage(JSON.parse(text).message)
                        })
                    } else {
                        const aLink = document.createElement('a')
                        let blob = new Blob([res], {
                            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        })
                        aLink.href = URL.createObjectURL(blob)
                        let name = `${$('.batch-purchase--upload').attr('data-excal')} ${this.form.first} ${this.form.last}`
                        aLink.setAttribute('download', name.replace(/\./g, '-'))
                        document.body.appendChild(aLink)
                        aLink.click()
                        document.body.removeChild(aLink)
                        if ($('.batch-purchase--upload').attr('data-download-success')) {
                            pushSuccessMessage($('.batch-purchase--upload').attr('data-download-success'))
                        }
                        this.handleUploadCose()
                        // 传递ga事件
                        const items = []
                        this.list.forEach(item => {
                            const {quantity, totalPrice, variantId, sku, title } = item
                            items.push({
                                item_id: variantId,
                                item_name: title,
                                item_variant: sku,
                                price: formatMoney(totalPrice / quantity, this.moneyFormat),
                                quantity: quantity
                            })
                        })
                        const gaParams = {
                            module: this.module,
                            value: this.totalPriceFormat,
                            currency: pageInfo.currency.currency,
                            button_name: text,
                            transaction_id: `${Shopify.country}${new Date().getTime()}`,
                            items
                        }
                        this.handleGa(gaParams)
                    }
                } catch (err) {
                    pushErrorMessage(err.message)
                } finally {
                    this.submitUploadLoading = false
                }
            },
            // 下载日站报价单
            async handleDownloadJp(text,limitPrice,msg) {
                if (this.handleCheck(false)) {
                    return false
                }
                this.submitUploadLoading = true
                const cardLists = []
                this.list.forEach(item => {
                    const {title, price, quantity, totalPrice, modelNumber } = item
                    const obj = {
                        modelNumber,
                        goodsName: title,
                        price,
                        discountPrice: totalPrice / quantity,
                        nums: quantity,
                        total: totalPrice
                    }
                    cardLists.push(obj)
                })
                const localLimitPrice = limitPrice ? Number(limitPrice) * 100 : 0;
                const params = {
                    ...this.form,
                    limitPrice: localLimitPrice,
                    cardLists
                }
                try {
                    const res = await downloadJpBatchPurchaseExcal(params)
                    if (res.type === 'application/json') {
                        res.text().then(text => {
                            const data = JSON.parse(text);
                            pushErrorMessage(data.code == 60001 ? (msg || data.message) : data.message);
                        })
                    } else {
                        const aLink = document.createElement('a')
                        let blob = new Blob([res], {
                            type: 'application/pdf',
                        })
                        aLink.href = URL.createObjectURL(blob)
                        let name = `${$('.batch-purchase--upload').attr('data-excal')} ${this.form.company} 様`
                        aLink.setAttribute('download', name.replace(/\./g, '-'))
                        document.body.appendChild(aLink)
                        aLink.click()
                        document.body.removeChild(aLink)
                        if ($('.batch-purchase--upload').attr('data-download-success')) {
                            pushSuccessMessage($('.batch-purchase--upload').attr('data-download-success'))
                        }
                        this.handleUploadCose()
                        // 传递ga事件
                        const items = []
                        let position = ''
                        this.list.forEach(item => {
                            const {quantity, totalPrice, variantId, sku, title } = item
                            items.push({
                                item_id: variantId,
                                item_name: title,
                                item_variant: sku,
                                price: formatMoney(totalPrice / quantity, this.moneyFormat),
                                quantity: quantity
                            })
                            position += `${title} x ${quantity},`
                        })
                        const gaParams = {
                            module: this.module,
                            value: this.totalPriceFormat,
                            currency: pageInfo.currency.currency,
                            button_name: text,
                            transaction_id: `${Shopify.country}${new Date().getTime()}`,
                            position,
                            items
                        }
                        this.handleGa(gaParams)
                    }
                } catch (err) {
                    pushErrorMessage(err.message)
                } finally {
                    this.submitUploadLoading = false
                }
            },
            // 类型切换
            handleTailorMinus(item) {
                let num = parseInt(item.quantity)
                if (item.quantity > 1) {
                    item.quantity = num - 1
                } else {
                    if (item.variantId !== '' && item.type !== '' && this.tailorList.length > 1) {
                        const i = this.tailorList.findIndex(it => it.variantId == item.variantId)
                        this.tailorList.splice(i, 1)
                    }
                }
            },
            handleTailorPlus(item) {
                let num = parseInt(item.quantity)
                item.quantity = num + 1
            },
            handleTailorInput(e, item) {
                const val = e.target.value
                item.quantity = val.replace(/^(0+)|[^\d]+/g,'')
            },
            // tail更改
            handleTailorTypeChange(e, it ,index) {
                const v = e.target.value
                it.variantId = ''
                const variantIds = this.tailorList.filter(item => item.variantId).map(item => item.variantId)
                it.list = this.productList.filter(item => !variantIds.includes(item.variantId)).filter(item => item.type === v)
                this.formErrors[index].type = ''
            },
            handleTailorChange(e, it ,index) {
                const v = e.target.value
                const obj = it.list.find(item => item.variantId == v)
                it.quantity = obj.quantity || 1
                this.formErrors[index].variantId = ''
            },
            async handleViewQuote(module) {
                this.module = module
                this.quoteButtonLoading = true
                try {
                    const arr = this.tailorList.filter(item => item.variantId && item.quantity)
                    this.list = []
                    const list = []
                     this.formErrors = this.formErrors.map(() => ({
                        type: '',
                        variantId: ''
                    })); // 重置

                    this.tailorList.forEach((item, index) => {
                        if (!item.type) {
                            this.formErrors[index].type = this.require;
                        }
                        if (!item.variantId) {
                            this.formErrors[index].variantId = this.require;
                        }
                    });

                    this.productList.forEach(item => {
                        arr.forEach(item1 => {
                            if (item1.variantId == item.variantId) {
                                const obj = {
                                    ...item,
                                    quantity: +item1.quantity,
                                    description: $(`.description-${item.sku}`).html()
                                }
                                list.push(obj)
                            }
                        })
                    })
                    list.forEach(item => {
                        const it = this.calcItemTotal(item)
                        this.list.push(it)
                    })
                    this.calcTotal()
                    // const allEmpty = this.formErrors.every(
                    //   (item) => item.type === "" && item.variantId === ""
                    // );
                    if(pageInfo.cr == 'JP' && this.require){
                        if (this.list.length > 0) {
                            this.handleProductModalShow()
                        }else{
                            pushErrorMessage(this.require);
                        }
                    }else{
                        if (this.list.length > 0) {
                            this.handleProductModalShow()
                        }
                    }

                } finally {
                    this.quoteButtonLoading = false
                }
            },
            currentTab(windowScrollTop) {
                const that = this
                $('.batch-purchase--product').each(function() {
                    const top = $(this).offset().top
                    const diffVal =  windowScrollTop - top;
                    if (diffVal > -70 && diffVal < 200) {
                        const clas = $(this).attr('class').split(' ')[2]
                        that.active = clas
                    }
                })
            },
            handleGa(params) {
                window.dataLayer.push({ "event_parameters": null });
                window.dataLayer.push({
                    event: "ga4Event",
                    event_name: "bulk_program_user_clicks",
                    event_parameters:{
                        "current_page": window.location.href,
                        ...params
                    }
                });
            },
            handleModalInput(e, item) {
                const val = e.target.value
                item.quantity = val.replace(/^(0+)|[^\d]+/g,'')
            },
            handlePhoneInput(e) {
                const val = e.target.value
                this.form.phone = val.replace(/[^\d]+/g,'')
            },
            // 立即购买
            async handleBuy() {
                const params = this.list.map(item => ({
                    id: item.variantId,
                    quantity: item.quantity,
                    properties: {
                        Action: 'Bulk-Program'
                    },
                }))

                try {
                    const checkoutUrl = await createCartAndCheckout(params)
                    if (checkoutUrl) {
                        window.location.href = checkoutUrl
                        // 传递ga事件
                        const items = []
                        this.list.forEach(item => {
                            items.push({
                                item_id: item.variantId,
                                item_name: item.title,
                                item_variant: item.sku,
                                price: formatMoney(item.price, this.moneyFormat),
                                quantity: item.quantity
                            })
                        })
                        const gaParams = {
                            module: this.module,
                            value: formatMoney(Math.ceil(this.totalPrice), this.moneyFormat),
                            currency: pageInfo.currency.currency,
                            button_name: $('.batch-purchase-buy').text(),
                            transaction_id: `${Shopify.country}${new Date().getTime()}`,
                            items
                        }
                        this.handleGa(gaParams)
                    }
                } catch (error) {
                    let str = '/cart/'
                    const properties = window.btoa(unescape(encodeURIComponent(JSON.stringify({
                        Action: 'Bulk-Program'
                    }))))
                    this.list.forEach(item => {
                        str += `${item.id}:${item.quantity},`
                    })
                    str = `${str.substring(0,str.length -1)}?traffic_source=buy_now&properties=${properties}`
                    window.location.href = str
                }
            },
            async getStates() {
                const res = await countryStreetInfo({cr: shopCR})
                this.stateList = res.data.province
            },
            // 监听页面滚动
            pageScrollListener() {
                // const $siteHeader = $('.site-header') || $('jky-header');
                // let headerH;
                $(window).scroll(() => {
                    const windowScrollTop = $(window).scrollTop();
                    this.currentTab(windowScrollTop)
                })
            }
        },
        async mounted() {
             const number = Number($('.tailor-content').attr('data-number')) || 1;
             this.require = $('.tailor-content').attr('data-require') || '';
             this.tailorNumber = number;
             this.tailorList = Array.from({ length: this.tailorNumber }, () => ({
                type: '',
                variantId: undefined,
                quantity: 1,
                list: []
                }));
            // 初始化 formErrors
            this.formErrors = Array.from({ length: this.tailorNumber }, () => ({
                type: '',
                variantId: ''
            }));

            this.pageScrollListener()
            await this.getList()
            this.getStates()
        }
    }).mount('#batch-purchase')
})
